import { Stepper, Container } from '@jcom/common-components';
import React from 'react';
import { Carousel, Image, Button } from 'react-bootstrap';
import { goBack, stoleImages } from '../../Utils/HomeUtil';
import ImageWrapper from '../ImageBuilderWrapper/ImageWrapper';
import ZoneDesignSection from "../ZoneDesign/ZoneDesign";
import BrandingSection from "../Branding/Branding";
import ReviewOrder from '../ReviewOrder/ReviewOrder';

const DesktopHome = (props) => {
	return (
		<div className='row App'>
			<div
				className='col-sm-12 col-12 col-md-6 designbody'
				id='mobile-designbody'>
				<div className='row mobile-alt'>
					<div className='col-2 mobile-icons'>
						<div className='leftside-icons'>
							<div
								className={` preview-buttons ${
									props.previewImage ? 'disable-btn' : 'cursor-pointer'
								}`}
								onClick={() => !props.previewImage && props.setZoomImage(false)}
								id='resetButton'>
								<i className='fal fa-undo'></i>
								<br />
								<span>
									{props.stoleMeta && props.stoleMeta.icon && props.stoleMeta.icon.resetIcon}
								</span>
							</div>
							<div
								className={` preview-buttons ${
									props.previewImage ? 'disable-btn' : 'cursor-pointer'
								}`}
								onClick={() => !props.previewImage && props.setZoomImage(true)}
								id='zoomButton'>
								<i className='fal fa-search-plus'></i>
								<br />
								<span>
									{props.stoleMeta && props.stoleMeta.icon && props.stoleMeta.icon.zoomIcon}
								</span>
							</div>
						</div>
					</div>
					<div className='col-10 col-xs-12'>
						<Carousel
							activeIndex={props.activeIndex}
							className='image-preview'
							controls={false}
							indicators={false}>
							<Carousel.Item key={1}>
								{props.selectedTemplate && props.activeIndex === 0 && (
									<ImageWrapper
										template={props.selectedTemplate}
										colorsList={props.colorList}
										id={1}
										zoomImage={props.zoomImage}
										cssClassName={'svg-div'}
										viewBox={'-300 0 1650.8 3060.8'}
										setLoading={props.setLoading}
										zoneImagePath={props.zoneImagePath}
										setZoneImagePath={props.setZoneImagePath}
									/>
								)}
							</Carousel.Item>
							<Carousel.Item key={2}>
								{props.altImage && (
									<Image
										src={process.env.REACT_APP_JOSTENS_CDN_HOST + props.altImage}
										className='alt-image secound-slide'
										alt='stole-layout'
									/>
								)}
							</Carousel.Item>
							<Carousel.Item key={3}>
								{props.previewImage && (
									<Image
										src={process.env.REACT_APP_JOSTENS_CDN_HOST + props.previewImage}
										alt='stole-preview'
										className='preview-image'
									/>
								)}
							</Carousel.Item>
						</Carousel>
						<div className='thumbnail-div'>
							<div
								className={`img-thumbnail thumbnail first-thumbnail ${
									props.activeIndex === 0 ? 'thumbnail-active' : ''
								}`}
								onClick={() => {
									props.setActiveIndex(0);
									props.previewImage && props.setPreviewImage('');
								}}>
								{props.selectedTemplate && (
									<ImageWrapper
										template={props.selectedTemplate}
										colorsList={props.colorList}
										id={2}
										zoomImage={false}
										cssClassName={'alt-wrapper '}
										viewBox={'-300 0 1718.8 3060.8'}
										setLoading={props.setLoading}
										zoneImagePath={props.zoneImagePath}
										setZoneImagePath={props.setZoneImagePath}
									/>
								)}
							</div>
							<div
								className={`img-thumbnail thumbnail secound-thumbnail ${
									props.activeIndex === 1 ? 'thumbnail-active' : ''
								}`}
								onClick={() => {
									props.setActiveIndex(1);
                  props.previewImage && props.setPreviewImage('');
								}}>
								{props.altImage && (
									<Image
										src={process.env.REACT_APP_JOSTENS_CDN_HOST + props.altImage}
										className='alt-image-thumbnail'
										alt='stole-layout-thumbnail'
									/>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className='col-sm-12 col-md-6 col-12 designbody'>
				<Stepper
					steps={props.steps}
					activeStep={props.currentStep}
					activeColor='#212121'
					completeColor='#167f06'
				/>
				<Container
					header={
						<p className='headerComponent'>
							<span className='spanTitle'>{props.headerText}</span>
						</p>
					}
					body={
						props.selectedStage === 'stole-design' ? (
							<>
								<p className='StolePara'>
									{props.stoleMeta &&
										props.stoleMeta.configContainer &&
										props.stoleMeta.configContainer.bodyTitle}
								</p>
								<div className='row desktopview'>
									{stoleImages.map((image, index) => (
										<div className='col' key={image.id}>
											<div className='design-title'>{image.title}</div>
											<div className='design-price'>
												{props.stoleMeta &&
													props.stoleMeta.configContainer &&
													props.stoleMeta.configContainer.stoles[index]
														.pricePrefix}{' '}
												${props.stolePrice[image.id]}
											</div>
											<div className='design-zone'>
												{props.stoleMeta &&
													props.stoleMeta.configContainer &&
													props.stoleMeta.configContainer.stoles[index].variantInfo}
											</div>
											{props.stoleType === image.id ? (
												<div className='icon_position'>
													<div className='select_icon'>
														<i className='tick'></i>
													</div>
												</div>
											) : (
												''
											)}
											<img
												id={image.id}
												className={
													props.stoleType === image.id
														? 'mt-3 img-select img-select-active'
														: 'mt-3 img-select'
												}
												onClick={(e) => props.selectImage(e)}
												src={props.stoleImagePath[image.id]}
												alt={image.id}
											/>
										</div>
									))}
								</div>
							</>
						) : props.selectedStage === 'school-branding' ? (
							<BrandingSection
								selectedTemplate={props.selectedTemplate}
								assetGroups={props.assetGroups}
								updateSelectedData={props.updateSelectedTemplate}
								colorList={props.colorList}
								stoleMeta={props.stoleMeta}
								brandingTab={props.brandingTab}
								setBrandingTab={props.setBrandingTab}
								getTabName={props.getBrandingTabName}
								setLoading={props.setLoading}
								fontList={props.fontList}
								getFontList={props.getFontList}
								zoneImagePath={props.zoneImagePath}
								setZoneImagePath={props.setZoneImagePath}
							/>
						) : props.selectedStage.indexOf('your-stole') !== -1 ? (
							<ZoneDesignSection
								key={props.selectedZone}
								selectedZone={props.selectedZone}
								designSettings={props.selectedTemplate.designSettings}
								zoneAssets={props.zoneAssets}
								assetGroups={props.assetGroups}
								colorList={props.colorList}
								updateZoneData={props.updateZoneData}
								stoleMeta={props.stoleMeta}
								stolePreview={()=>props.stolePreview()}
								getTabName={props.getZoneTabName}
								fontList={props.fontList}
								getFontList={props.getFontList}
								zoneImagePath={props.zoneImagePath}
								setZoneImagePath={props.setZoneImagePath}
								zoneTextStatus={props.zoneTextStatus}
								setZoneTextStaus={props.setZoneTextStaus}
							/>
						) : (
							props.selectedStage === 'review-order' && (
								<ReviewOrder
									checkBoxValue={props.checkBoxValue}
									roZoneAssets={props.zoneAssets}
									sampleData={props.selectedTemplate}
									commonJSONText={props.stoleMeta}
									setSelectedStage={props.setSelectedStage}
									getRoPayload={props.getRoPayload}
									stoleType={props.stoleType}
									stolePreview={props.stolePreview}
									stoleMeta={props.stoleMeta}
									getTabName={props.getZoneTabName}
									colorList={props.colorList}
									fontList={props.fontList}
									getFontList={props.getFontList}
									substemNameBranding={props.substemNameBranding}
									brandingTab={props.brandingTab}
									selectedStage={props.selectedStage}
									currentStep={props.currentStep}
									estimatedPrice={props.estimatedPrice}
								/>
							)
						)
					}
					footer={
						<div className='footerComponent'>
							{
								<>
									{props.selectedStage !== 'stole-design' && (
										<>
											<Button
												className='footer-btn-left'
												onClick={() => {
													goBack(
														props.selectedTemplate,
														props.selectedStage,
														props.setSelectedStage,
														props.setBrandingTab,
														props.brandingTab
													);
												}}
												variant='white'>
												{props.stoleMeta &&
													props.stoleMeta.configContainer &&
													props.stoleMeta.configContainer.footer &&
													props.stoleMeta.configContainer.footer.backBtn}
											</Button>
											<Button
												className='footer-btn-left'
												onClick={() => props.saveDesignFromModalShow(true)}
												data-test='saveDesign'
												variant='white'>
												{props.stoleMeta &&
													props.stoleMeta.configContainer &&
													props.stoleMeta.configContainer.footer &&
													props.stoleMeta.configContainer.footer.saveBtn}
											</Button>
										</>
									)}
									<Button
										id='rightButton'
										className='footer-btn-right'
										variant='black'
										onClick={() => {
											props.next()
										}}>
										{props.buttonText}&nbsp;&nbsp;
										<i className='fas fa-arrow-right'></i>
									</Button>
								</>
							}
						</div>
					}
				/>
			</div>
		</div>
	);
};
export default DesktopHome;